export default "__VITE_ASSET__CxYEHvxg__"